// NOSONAR
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Optional } from '@angular/core';
import { Configuration, HttpRequestOptions, MessageService, SiteService } from '@sla-ng/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class CostAccountingRequestService {

    public authToken: string;
    protected configuration: Configuration;

    private isLogEnabled: boolean;

    constructor(protected myHttpClient: HttpClient,
                protected mySiteService: SiteService,
                protected myMessageService: MessageService,
                @Optional() configuration: Configuration,
    ) {
        this.configuration = configuration;
    }

    /**
     * (usually) for SELECTs
     */
    public get<T>(target: string, options?: HttpRequestOptions, skipDefaultErrorHandling?: boolean): Observable<T> {

        const url: string = this.getURL(target);
        const args: HttpRequestOptions = this.createArgs(options);

        return this.myHttpClient.get<T>(url, args).pipe(catchError((error: HttpErrorResponse) => this.handleError(error, skipDefaultErrorHandling)));
    }

    /**
     * (usually) for INSERTs
     */
    public post<T, T1>(target: string, body: T1, options?: HttpRequestOptions, skipDefaultErrorHandling?: boolean): Observable<T> {

        const url: string = this.getURL(target);
        const args: HttpRequestOptions = this.createArgs(options);
        return this.myHttpClient.post<T>(url, body, args).pipe(catchError((error: HttpErrorResponse) => this.handleError(error, skipDefaultErrorHandling)));
    }

    /**
     * (usually) for UPDATEs
     */
    public put<T, T1>(target: string, body: T1, options?: HttpRequestOptions, skipDefaultErrorHandling?: boolean): Observable<T> {

        const url: string = this.getURL(target);
        const args: HttpRequestOptions = this.createArgs(options);

        return this.myHttpClient.put<T>(url, body, args).pipe(catchError((error: HttpErrorResponse) => this.handleError(error, skipDefaultErrorHandling)));
    }

    /**
     * (usually) for DELETEs
     */
    public delete<T>(target: string, options?: HttpRequestOptions, skipDefaultErrorHandling?: boolean): Observable<T> {

        // Hallo
        const url: string = this.getURL(target);
        const args: HttpRequestOptions = this.createArgs(options);

        return this.myHttpClient.delete<T>(url, args).pipe(catchError((error: HttpErrorResponse) => this.handleError(error, skipDefaultErrorHandling)));
    }

    /**
     * (usually) for cache invalidation of SELECTs
     */
    public head<T>(target: string, options?: HttpRequestOptions, skipDefaultErrorHandling?: boolean): Observable<T> {

        const url: string = this.getURL(target);
        const args: HttpRequestOptions = this.createArgs(options);

        return this.myHttpClient.head<T>(url, args).pipe(catchError((error: HttpErrorResponse) => this.handleError(error, skipDefaultErrorHandling)));
    }

    /**
     * (usually) for partial UPDATESs (rarely implemented!)
     */
    public patch<T, T1>(target: string, body: T1, options?: HttpRequestOptions, skipDefaultErrorHandling?: boolean): Observable<T> {

        const url: string = this.getURL(target);
        const args: HttpRequestOptions = this.createArgs(options);

        return this.myHttpClient.patch<T>(url, body, args).pipe(catchError((error: HttpErrorResponse) => this.handleError(error, skipDefaultErrorHandling)));
    }

    public setToken(token: string): void {
        this.authToken = token;
    }

    public handleError(error: Error | HttpErrorResponse, skipDefaultErrorHandling?: boolean): Observable<never> {
        if (skipDefaultErrorHandling) {
            return throwError(error);
        }

        // if (this.isLogEnabled) {
        //     const logApiEntry: LogApiEntry = new LogApiEntry('ERROR', new Date().toString(), error.message);
        //     try {
        //         const args: HttpRequestOptions = this.createArgs(null);
        //         firstValueFrom(this.myHttpClient.post(this.getURL('log'), logApiEntry, args));
        //     } catch (e) {
        //         console.error(e);
        //     }
        // }
        return throwError(() => error);
    }

    // -----

    public getURL(target: string): string {
        const basePath: { web: string, rest: string } = { web: null, rest: this.mySiteService.getConfigKey('rest') };
        // const apiVersion: string = this.version.version.match(/(.*(?=\.))|(?<=\.).*/g)[ 0 ].replace(/\./g, '-');
        // if (this.configuration != null && this.configuration.getBasePath) {
        //     basePath = this.configuration.getBasePath();
        // }
        //
        // if (window.location.href.includes(`/ui/${apiVersion}`)) {
        //     basePath = { web: `${window.location.origin}/`, rest: `${window.location.origin}/api/` };
        //     console.log('overriden config');
        // } else {
        //     if (target === 'version') {
        //         return `${basePath.rest}${target}`;
        //     }
        // }

        return `${basePath.rest}/${target}`;
        // return `${basePath.rest}${target}`;
    }

    protected createArgs(options?: HttpRequestOptions): HttpRequestOptions {
        if (options instanceof HttpRequestOptions) {
            return options;
        } else {
            const args: HttpRequestOptions = {
                params: this.createParamsArgs(options),
                headers: this.createHeaderArgs(options),
                withCredentials: true,
            };
            return args;
        }
    }

    protected createParamsArgs(options?: HttpRequestOptions): HttpParams {
        let params: HttpParams = new HttpParams();

        if (typeof options?.params !== 'undefined'
            && options.params !== null) {

            const paramKeyArray: string[] = Object.keys(options.params);

            paramKeyArray.forEach((key: string) => {
                const paramValue: string = options.params[ key ];
                params = params.append(key, paramValue);
            });
        }
        return params;
    }

    protected createHeaderArgs(options?: HttpRequestOptions): HttpHeaders {
        let headers: HttpHeaders;
        if (this.authToken != null) {
            headers = new HttpHeaders({ Authorization: `Bearer ${this.authToken}` }).set('Content-Type', 'application/json');
        } else {
            headers = new HttpHeaders().set('Content-Type', 'application/json');
        }

        if (options?.headers != null) {
            (options.headers as HttpHeaders).keys().forEach((key: string) => {
                const value: string = (options.headers as HttpHeaders).get(key);
                headers = headers.append(key, value);
            });
        }
        return headers;
    }
}
